<ion-header>
  <ion-toolbar class="thin-toolbar background-background" mode="ios">
    <frontend-header routeId="history"></frontend-header>
  </ion-toolbar>
</ion-header>

<ion-content [forceOverscroll]="false">
  <frontend-pull-refresh></frontend-pull-refresh>

  <div>
    <div class="search-row">
      <tablesready-search-bar
        #searchBarRef
        [placeholder]="'Search recent ' + customer_plural"
        (search)="updateSearchQuery($event)"
      ></tablesready-search-bar>
    </div>

    <div class="overflow-auto">
      <table *ngIf="parties.length; else message" class="table table-striped tr-table">
        <thead>
        <tr>
          <th>
            <tablesready-sortable-column
              [sortBy]="sortBy"
              column="close_time"
              title="time"
              [orderAscending]="sortReverse"
              (orderBy)="orderBy($event)"
            ></tablesready-sortable-column>
          </th>
          <th>
            <tablesready-sortable-column
              [sortBy]="sortBy"
              column="name"
              [title]="customer | titlecase"
              [orderAscending]="sortReverse"
              (orderBy)="orderBy($event)"
            ></tablesready-sortable-column>
          </th>
          <th>
            <tablesready-sortable-column
              [sortBy]="sortBy"
              column="size"
              title="size"
              [orderAscending]="sortReverse"
              (orderBy)="orderBy($event)"
            ></tablesready-sortable-column>
          </th>
          <th>
            <tablesready-sortable-column
              [sortBy]="sortBy"
              column="note"
              title="notes"
              [orderAscending]="sortReverse"
              (orderBy)="orderBy($event)"
            ></tablesready-sortable-column>
          </th>
          <th *ngIf="serviceSettings?.enabled && services.length > 0">
            {{serviceSettings?.label}}
          </th>
          <th *ngIf="resourceSettings?.enabled && resources.length > 0">
            {{resourceSettings?.label}}
          </th>
          <th>Paging</th>
          <th>Update</th>
        </tr>
        </thead>
        <tbody>
        <ng-container  *ngFor="let party of parties; index as i;">
          <tr [@moveParty]="party.isHidden ? 'collapsed' : 'expanded'">
            <td>
              <span class="d-xs-inline d-sm-none">Time: </span>
              {{party.close_time | trDateFormat:'h:mm a':timezone}}<div class="d-none d-sm-block"></div>
              {{party.close_time | trDateFormat:'M/D/yy':timezone}}
            </td>
            <td>
              {{party.name}}

              <tablesready-party-badge
                [party]="party"
              ></tablesready-party-badge>
              <shared-badge
                *ngIf="unpaid(party)"
                [label]="'Unpaid'"
                [class]="'badge badge-pill badge-danger'"
              ></shared-badge>
              <shared-badge
                *ngIf="paid(party)"
                [label]="'Paid'"
                [class]="'badge badge-pill badge-success'"
              ></shared-badge>
              <shared-badge
                *ngIf="refunded(party)"
                [label]="'Refunded'"
                [class]="'badge badge-pill badge-info'"
              ></shared-badge>

              <span *ngIf="paid(party) && party.stripeData?.paymentLink"><br/>
              <a class="text-link" [href]="party.stripeData?.paymentLink" target="_blank">Manage Payment</a>
            </span>
              <span *ngIf="party.phone"><br/>{{party.phone}}</span>
              <span *ngIf="party.loyalty_count > 0"><br/>Recent visits: {{party.loyalty_count}}</span>
            </td>
            <td>
              <span class="d-xs-inline d-sm-none">Size: </span>
              {{party.size}}
            </td>
            <td class="notes-and-services">
              <span *ngIf="party.note">{{customer | titlecase}} note: {{isArray(party.note) ? party.note.join(', ') : party.note}}<br/></span>
              <span *ngIf="party.close_time">{{reason(party) }} {{ reasonTime(party) | trTimeDelta }} ago.</span>
              <span *ngIf="party.seated_time && party.checkin_time"><br/>Waited {{ (party.seated_time - party.checkin_time) | trTimeDelta }}.</span>
              <span *ngIf="party.type === partyTypes.reservation"><br/>Originally scheduled: {{ party.quoted_time  | trDateFormat:'M/D/yy, h:mm a':timezone }}</span>
            </td>
            <td class="notes-and-services" *ngIf="serviceSettings?.enabled && services.length > 0">
              <tablesready-model-name-display [id]="party.services" [models]="services"></tablesready-model-name-display>
            </td>
            <td class="notes-and-services" *ngIf="resourceSettings?.enabled && resources.length > 0">
              <tablesready-model-name-display [id]="party.resources" [models]="resources"></tablesready-model-name-display>
            </td>
            <td>
              <ul *ngIf="party.notifications" class="sms-messages list-unstyled tr-icon-list mb-1 mt-2">
                <li *ngFor="let message of getPartyNotifications(party)" class="flex">
                    <span *ngIf="isInProgressStatus(message)"
                          class="spinner tr-bullet d-flex flex-nowrap justify-content-between align-items-center">
                          <div class="bounce1"></div>
                          <div class="bounce2"></div>
                          <div class="bounce3"></div>
                    </span>
                  <tr-icon *ngIf="isSentSmsStatus(message)" [icon]="icon.send" class="tr-bullet"></tr-icon>
                  <tr-icon *ngIf="isSentVoiceStatus(message)" [icon]="icon.call" classes="tr-bullet"></tr-icon>
                  <tr-icon *ngIf="isNotSentStatus(message)" [icon]="icon.info" classes="tr-bullet"></tr-icon>
                  <tr-icon *ngIf="message.Body" [icon]="icon.send" classes="tr-bullet"></tr-icon>
                  <span class="ml-1 mr-1">{{ message.type | prettifyNotificationType }}</span>
                  <span> ({{ (now - message.time) | trTimeDelta }} ago)</span>
                </li>
                <li *ngIf="showViewAllMessages(party)">
                  <a [routerLink]="[]" (click)="viewMessagesHistory(party)">View all</a>
                </li>
              </ul>
            </td>
            <td>
              <button
                class="btn btn-info btn-icon text-nowrap"
                (click)="moveToWaitlist(party)"
                [disabled]="refunded(party) || (party.type === partyTypes.togo && (!account.features.togo || !location.displayOptions.togo))"
              >
                <span class="bi bi-reply-fill"></span> {{ getBtnName(party) }}
              </button>
            </td>
          </tr>
        </ng-container>
        </tbody>
      </table>
    </div>
  </div>

  <ion-infinite-scroll (ionInfinite)="onIonInfinite($event)">
    <ion-infinite-scroll-content></ion-infinite-scroll-content>
  </ion-infinite-scroll>

  <ng-template #message>
    <p class="m-2">
      No recent {{customer_plural}}
    </p>
  </ng-template>
</ion-content>
